import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import NProgress from "nprogress";

import useAsyncState from "../../hooks/useAsyncState";
import API from "../../api/user";
import convertJsonToCsv from "../../utils/convertJsonToCsv";
import ServerErrorMessage from "../atoms/ServerErrorMessage";
import Button from "../atoms/Button";
import LinkHandler from "../atoms/LinkHandler";
import { customValidators } from "../../utils/validators";
// @ts-ignore
import { ReactForm, ReactFormField } from "@adrenalin/react-form";

interface PropsType extends RouteComponentProps {
    id: any;
    club: any;
}

const ManageClubsMembersBody = (props: PropsType) => {
    const [state, localActions] = useAsyncState();

    const handleDownloadMemberListClick = () => {
        if (props.id) {
            NProgress.start();
            localActions.request();

            API.userGetManagedClubMembers(props.id)
                .then(response => {
                    if (response.length > 0) {
                        convertJsonToCsv(
                            response.map(member => ({
                                ...member,
                                price_paid: `$${member?.price_paid?.toFixed?.(
                                    2
                                )}`,
                            })),
                            `${props.club.post_title} - Club Members`
                        );

                        // success
                        localActions.success();
                    } else {
                        localActions.fail(
                            "There are no current members in this club."
                        );
                    }
                })
                .catch(error => {
                    // errors
                    localActions.fail(error.message);
                })
                .finally(() => {
                    NProgress.done();
                });
        }
    };

    return (
        <div className="row manage-clubs-members-body">
            <div className="col-xs-12">
                <div className="row">
                    <div className="col-xs-12">
                        <div>
                            <h2 className="heading-1-v2 manage-clubs-members-body__title">
                                Membership list
                            </h2>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <div className="rich-text-content rich-text-content--small">
                            <p>
                                As a club executive you can access a dynamic
                                membership list for your club here. This list
                                will automatically update as your memberships
                                grow, so ensure you download an updated list
                                before sending out any communications to your
                                club.
                            </p>
                            <p>Notes:</p>
                            <ul>
                                <li>
                                    All clubs are required to adhere to
                                    ActivateUTS's{" "}
                                    <LinkHandler to="/activateuts-policies/privacy-policy/">
                                        Privacy Policy
                                    </LinkHandler>{" "}
                                    when using their membership data. Check out{" "}
                                    <LinkHandler to="/club-resources/">
                                        Club Resources
                                    </LinkHandler>{" "}
                                    for full guidelines on use of data.
                                </li>
                                <li>
                                    Clubs are required to report any unsubscribe
                                    requests to ActivateUTS via{" "}
                                    <a href="mailto:ActivateUTS.Marketing@uts.edu.au">
                                        ActivateUTS.Marketing@uts.edu.au
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <ReactForm
                            validators={customValidators}
                            onSuccess={handleDownloadMemberListClick}
                            disableErrorScroll={true}
                        >
                            <ReactFormField
                                type="checkbox"
                                label={
                                    <span>
                                        All membership data accessed will be
                                        stored securely and used in accordance
                                        with{" "}
                                        <a
                                            href="https://www.acma.gov.au/avoid-sending-spam"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            Australia Spam Regulations
                                        </a>
                                    </span>
                                }
                                name="compliancecheckbox"
                                required={true}
                                defaultChecked={false}
                            />

                            <Button
                                type="submit"
                                styles={["green"]}
                                className="manage-clubs-members-body__btn"
                                aria-label="Download member list"
                                loading={state.loading}
                                success={!!state.success}
                            >
                                Download member list
                            </Button>
                        </ReactForm>
                        <ServerErrorMessage>{state.error}</ServerErrorMessage>
                    </div>
                </div>
            </div>
        </div>
    );
};

ManageClubsMembersBody.preload = ({
    location,
    passed: { store },
}: any): Promise<any> => {
    return Promise.all([]);
};

export default withRouter(ManageClubsMembersBody);
